import React, { useRef } from "react"
import { useOutletContext } from "react-router-dom"

import hasAccess from "@api/hasAccess"
import { W0, W1, W5 } from "@components/constants"
import { ProjectUpdateModal } from "@modules/backstage/projects"
import {
  ProjectPropertyCreateModal,
  ProjectPropertyUpdateModal,
  ConnectFundProjectPropertyModal
} from "@modules/backstage/properties"

import {
  ProjectDetails,
  ProjectDetailsContext,
} from "@components/ProjectDetails"


const ProjectDetailsPage = () => {
  const {
    project,
    updateProject,
    updateProjectProperty,
    removeProjectProperty
  } = useOutletContext()

  const projectUpdateModal = useRef({})
  const propertyCreateModal = useRef({})
  const propertyUpdateModal = useRef({})
  const propertyConnectModal = useRef({})

  const openProjectUpdateModal = (onlyFieldNames, modalWidth) =>
    projectUpdateModal.current.open(onlyFieldNames, modalWidth)

  const openPropertyUpdateModal = propertyId =>
    propertyUpdateModal.current.openWithProperties(propertyId)

  const openPropertyCreateModal = () =>
    propertyCreateModal.current.openWithProperties()

  const openPropertyConnectModal = () =>
    propertyConnectModal.current.open()

  const context = {
    updateProject,
    updateProjectProperty,
    removeProjectProperty,
    openProjectUpdateModal,
    openPropertyCreateModal,
    openPropertyUpdateModal,
    openPropertyConnectModal,
  }

  const isEditable = hasAccess(['projects-write'])

  const style = {
    padding: `${W1 + W0}px ${W1 + W0}px ${W5}px`
  }

  return (
    <div style={style}>
      <ProjectDetailsContext.Provider value={context}>
        <ProjectDetails
          project={project}
          isEditable={isEditable}
        />

        <ProjectUpdateModal
          modal={projectUpdateModal}
          project={project}
        />

        <ProjectPropertyUpdateModal modal={propertyUpdateModal} />
        <ProjectPropertyCreateModal modal={propertyCreateModal} />
        <ConnectFundProjectPropertyModal modal={propertyConnectModal} />
      </ProjectDetailsContext.Provider>
    </div>
  )
}

export default ProjectDetailsPage
